import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { initGA } from "../lib/analytics";

export const ConsentBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("wmdw_consent")) setShow(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem("wmdw_consent", choice);
    if (choice === "granted") initGA();
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="consent-banner"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4"
        >
          <div className="mx-auto flex max-w-md flex-col gap-3 rounded-2xl border border-black/10 bg-white p-4 shadow-[0_12px_40px_rgba(0,0,0,0.15)]">
            <div className="flex items-start gap-3">
              <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-gold" strokeWidth={2.2} />
              <p className="text-sm text-zinc-600">
                We use cookies for <span className="font-semibold text-zinc-900">anonymous analytics</span> only
                — never to identify you or track your answers. Yep, we see the irony.
              </p>
            </div>
            <div className="flex gap-2">
              <button
                data-testid="consent-decline-btn"
                onClick={() => decide("denied")}
                className="flex-1 rounded-full border border-black/10 bg-white py-2.5 text-sm font-semibold text-zinc-600 transition-colors hover:text-zinc-900"
              >
                Decline
              </button>
              <button
                data-testid="consent-accept-btn"
                onClick={() => decide("granted")}
                className="flex-1 rounded-full bg-lime py-2.5 font-display text-sm font-bold text-black shadow-[0_6px_18px_rgba(204,255,0,0.4)] transition-transform active:scale-95"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
